<template>
  <footer class="footer">
    <!-- Main Footer Content -->
    <div class="footer-main">
      <div class="container">
        <div class="footer-grid">
          <!-- Company Info -->
          <div class="footer-col footer-about reveal-left">
            <div class="footer-logo">
              <div class="logo-icon">
                <img src="https://1500062809.vod-qcloud.com/6d053ea1vodcq1500062809/cefc037d5001834810594443328/JE36Y0C1bvQA.png" alt="Brand Logo">
              </div>
              <span class="logo-text">{{ $t('footer.logo') }}</span>
            </div>
            <p class="footer-desc">
              {{ $t('footer.desc') }}
            </p>
<!--            <div class="footer-social">-->
<!--              <a href="#" class="social-link" title="Facebook">-->
<!--                <i class="fab fa-facebook-f"></i>-->
<!--              </a>-->
<!--              <a href="#" class="social-link" title="Twitter">-->
<!--                <i class="fab fa-twitter"></i>-->
<!--              </a>-->
<!--              <a href="#" class="social-link" title="LinkedIn">-->
<!--                <i class="fab fa-linkedin-in"></i>-->
<!--              </a>-->
<!--              <a href="#" class="social-link" title="YouTube">-->
<!--                <i class="fab fa-youtube"></i>-->
<!--              </a>-->
<!--            </div>-->
          </div>

          <!-- Quick Links -->
          <div class="footer-col footer-links reveal" style="transition-delay: 0.1s;">
            <h4 class="footer-title">{{ $t('footer.links.title') }}</h4>
            <ul class="footer-list">
              <li>
                <router-link to="/">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.links.items.home') }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/about">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.links.items.about') }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.links.items.products') }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/news">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.links.items.news') }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/contact">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.links.items.contact') }}</span>
                </router-link>
              </li>
            </ul>
          </div>

          <!-- Products -->
          <div class="footer-col footer-products reveal" style="transition-delay: 0.2s;">
            <h4 class="footer-title">{{ $t('footer.products.title') }}</h4>
            <ul class="footer-list">
              <li>
                <a href="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.products.items.helmet') }}</span>
                </a>
              </li>
              <li>
                <a href="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.products.items.glasses') }}</span>
                </a>
              </li>
              <li>
                <a href="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.products.items.shield') }}</span>
                </a>
              </li>
              <li>
                <a href="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.products.items.mask') }}</span>
                </a>
              </li>
              <li>
                <a href="/products">
                  <i class="fas fa-chevron-right"></i>
                  <span>{{ $t('footer.products.items.goggles') }}</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- Contact Info -->
          <div class="footer-col footer-contact reveal-right">
            <h4 class="footer-title">{{ $t('footer.contact.title') }}</h4>
            <ul class="footer-contact-list">
              <li>
                <div class="contact-icon">
                  <i class="fas fa-map-marker-alt"></i>
                </div>
                <div class="contact-text">
                  <span>{{ $t('footer.contact.address') }}</span>
                  <p>{{ $t('footer.contact.addressValue') }}</p>
                </div>
              </li>
              <li>
                <div class="contact-icon">
                  <i class="fas fa-phone-alt"></i>
                </div>
                <div class="contact-text">
                  <span>{{ $t('footer.contact.phone') }}</span>
                  <p>+86 15163903660</p>
                </div>
              </li>
              <li>
                <div class="contact-icon">
                  <i class="fas fa-envelope"></i>
                </div>
                <div class="contact-text">
                  <span>{{ $t('footer.contact.email') }}</span>
                  <p>postmaster5@lyyllb.com</p>
                </div>
              </li>
<!--              <li>-->
<!--                <div class="contact-icon whatsapp">-->
<!--                  <i class="fab fa-whatsapp"></i>-->
<!--                </div>-->
<!--                <div class="contact-text">-->
<!--                  <span>WhatsApp</span>-->
<!--                  <p>+86 15163903660</p>-->
<!--                </div>-->
<!--              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Newsletter Section -->
    <div class="footer-newsletter">
      <div class="container">
        <div class="newsletter-wrapper reveal-scale">
          <div class="newsletter-content">
            <h4>{{ $t('footer.newsletter.title') }}</h4>
            <p>{{ $t('footer.newsletter.desc') }}</p>
          </div>
          <form class="newsletter-form" @submit.prevent="subscribeNewsletter">
            <input type="email" v-model="email" :placeholder="$t('footer.newsletter.placeholder')" required>
            <button type="submit" class="btn btn-subscribe">
              <i class="fas fa-paper-plane"></i>
              {{ $t('footer.newsletter.subscribe') }}
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom-content">
          <p class="copyright">
            © {{ currentYear }} {{ $t('footer.copyright.company') }} {{ $t('footer.copyright.reserved') }}
          </p>
          <div class="footer-badges">
            <span class="badge-item">
              <i class="fas fa-shield-alt"></i>
              {{ $t('footer.badges.quality') }}
            </span>
            <span class="badge-item">
              <i class="fas fa-truck"></i>
              {{ $t('footer.badges.delivery') }}
            </span>
            <span class="badge-item">
              <i class="fas fa-headset"></i>
              {{ $t('footer.badges.support') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Back to Top Button -->
    <button class="back-to-top" :class="{ 'visible': showBackToTop }" @click="scrollToTop">
      <i class="fas fa-chevron-up"></i>
    </button>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      email: '',
      showBackToTop: false,
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.initRevealAnimations()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 500
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    subscribeNewsletter() {
      if (this.email) {
        alert(this.$t('footer.newsletter.success'))
        this.email = ''
      }
    },
    initRevealAnimations() {
      const reveals = document.querySelectorAll('.footer .reveal, .footer .reveal-left, .footer .reveal-right, .footer .reveal-scale')

      const revealOnScroll = () => {
        reveals.forEach(element => {
          const windowHeight = window.innerHeight
          const elementTop = element.getBoundingClientRect().top
          const revealPoint = 100

          if (elementTop < windowHeight - revealPoint) {
            element.classList.add('active')
          }
        })
      }

      window.addEventListener('scroll', revealOnScroll)
      window.addEventListener('load', revealOnScroll)
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

/* Main Footer */
.footer-main {
  padding: 80px 0 60px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 50px;
}

/* Footer Logo */
.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.logo-icon {
  width: 50px;
  height: 50px;
  //background: linear-gradient(135deg, #e53935, #c62828);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.4rem;
  box-shadow: 0 5px 20px rgba(229, 57, 53, 0.4);
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.footer-desc {
  font-size: 0.95rem;
  line-height: 1.8;
  margin-bottom: 25px;
}

/* Social Links */
.footer-social {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #e53935;
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(229, 57, 53, 0.4);
}

/* Footer Title */
.footer-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 12px;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #e53935, #ff6f00);
  border-radius: 3px;
}

/* Footer Lists */
.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 12px;
}

.footer-list a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  transition: all 0.3s ease;
  text-decoration: none;
}

.footer-list a i {
  font-size: 0.7rem;
  color: #e53935;
  transition: transform 0.3s ease;
}

.footer-list a:hover {
  color: #e53935;
  padding-left: 5px;
}

.footer-list a:hover i {
  transform: translateX(3px);
}

/* Contact List */
.footer-contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-contact-list li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
}

.contact-icon {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e53935;
  font-size: 1rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.contact-icon.whatsapp {
  color: #25D366;
}

.contact-icon.whatsapp:hover {
  background: #25D366;
  color: white;
}

.footer-contact-list li:hover .contact-icon {
  background: #e53935;
  color: white;
}

.contact-text span {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-bottom: 3px;
}

.contact-text p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

/* Newsletter */
.footer-newsletter {
  padding: 0 0 60px;
}

.newsletter-wrapper {
  background: linear-gradient(135deg, rgba(229, 57, 53, 0.2), rgba(198, 40, 40, 0.1));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 40px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.newsletter-content h4 {
  font-size: 1.3rem;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
}

.newsletter-content p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.newsletter-form {
  display: flex;
  gap: 15px;
  flex: 1;
  max-width: 500px;
}

.newsletter-form input {
  flex: 1;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: white;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.newsletter-form input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.newsletter-form input:focus {
  outline: none;
  border-color: #e53935;
  background: rgba(255, 255, 255, 0.15);
}

.btn-subscribe {
  padding: 15px 30px;
  background: linear-gradient(135deg, #e53935, #c62828);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-subscribe:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(229, 57, 53, 0.4);
}

/* Footer Bottom */
.footer-bottom {
  background: rgba(0, 0, 0, 0.3);
  padding: 25px 0;
}

.footer-bottom-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.copyright {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.footer-badges {
  display: flex;
  gap: 25px;
}

.badge-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
}

.badge-item i {
  color: #e53935;
}

/* Back to Top */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #e53935, #c62828);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(229, 57, 53, 0.4);
  z-index: 100;
}

.back-to-top.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.back-to-top:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(229, 57, 53, 0.5);
}

/* Reveal Animations */
.reveal, .reveal-left, .reveal-right, .reveal-scale {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.reveal {
  transform: translateY(30px);
}

.reveal-left {
  transform: translateX(-40px);
}

.reveal-right {
  transform: translateX(40px);
}

.reveal-scale {
  transform: scale(0.95);
}

.reveal.active, .reveal-left.active, .reveal-right.active, .reveal-scale.active {
  opacity: 1;
  transform: translate(0) scale(1);
}

/* Responsive */
@media (max-width: 991px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .newsletter-wrapper {
    flex-direction: column;
    text-align: center;
    padding: 30px;
  }

  .newsletter-form {
    width: 100%;
    max-width: 100%;
    flex-direction: column;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
}

@media (max-width: 767px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-main {
    padding: 60px 0 40px;
  }

  .back-to-top {
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 45px;
  }
}
</style>
